import React from 'react';
import { Link } from 'react-router-dom';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import posts from '../posts.generated.json';
import { formatDate } from '../lib/format';
import '../styles/home.css';
import '../styles/blog.css';

function Blog() {
  return (
    <>
      <Nav />
      <main className="blog">
        <div className="wrap blog-head">
          <p className="eyebrow">Blog</p>
          <h1 className="h1 blog-head-title">Notes on noise.</h1>
          <p className="lead blog-head-lead">
            What we&rsquo;re learning about datacenter acoustics, the permitting
            fights it causes, and the physics underneath both.
          </p>
        </div>

        <div className="wrap blog-list">
          {posts.length === 0 ? (
            <p className="blog-empty">
              First post coming soon. In the meantime,{' '}
              <Link to="/#assessment" className="blog-empty-link">
                request a site assessment
              </Link>
              .
            </p>
          ) : (
            posts.map((post) => (
              <article className="blog-item" key={post.slug}>
                <Link to={`/blog/${post.slug}`} className="blog-item-link">
                  <div className="blog-item-meta">
                    <time dateTime={post.date}>{formatDate(post.date)}</time>
                    <span aria-hidden="true">&middot;</span>
                    <span>{post.readingMinutes} min read</span>
                    {post.draft && <span className="blog-draft-flag">Draft</span>}
                  </div>
                  <h2 className="blog-item-title">{post.title}</h2>
                  {post.summary && <p className="blog-item-summary">{post.summary}</p>}
                  <span className="link-arrow blog-item-more">
                    Read <span aria-hidden="true">&rarr;</span>
                  </span>
                </Link>
              </article>
            ))
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}

export default Blog;
